import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mark",
  "use": "icon-mark-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-mark\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#027D48\" />\r\n        <path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 16.68L13.285 20.239 21.501 11\" />\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol